import React from "react";
import {
  QueryResult,
  FilterWrapper,
  StyledMenu
} from "../../../../../../CommonComponents/TabsComponent/styles";
import { SearchInput } from "../RenderTable/style";
import funnel from "../../../../../../assets/icons/Funnel.png";
import MultiSelect from "../RenderTable/Select";
import TimeFrameComponent from "../DateTimepicker/TimeFrameComponent";
import { DropdownList } from "../../style";
import { FlexCentered, Blocks } from "./style";
import { SeachImage } from "../RenderTable/style";
import SearchIcon from "../../../../../../assets/icons/search-icon.svg";

const MobileSearch = props => {
  const { menu, handleSearch, cleared } = props;
  return (
    <>
      <Brain
        handleSearch={handleSearch}
        menu={menu}
        startDate={props.startDate}
        endDate={props.endDate}
        render={({
          state,
          handleSearch,
          searched,
          handleStatus,
          handleFrequency,
          dateValues
        }) => (
          <>
            <Blocks flex={1} overflow="scroll">
              <SearchInput
                id="txtGrantSearchMobile"
                placeholder="Search by charity"
                suffix={<SeachImage 
                  src={SearchIcon}
                  alt="search_icon"  
                  onClick={()=>handleSearch()} 
                  />}
                onPressEnter={e => handleSearch(e)}
                onChange={e => searched(e)}
                value={state.search}
                style={{ width: 200 }}
                mobileMargin
              />
              <FilterDropdown
                menu={menu}
                handleStatus={handleStatus}
                handleFrequency={handleFrequency}
                dateValues={dateValues}
                cleared={cleared}
              />
             
            </Blocks>
            {state.search && (
              <QueryResult> Showing Results for “{state.search}”</QueryResult>
            )}
          </>
        )}
      />
    </>
  );
};

export default MobileSearch;

export class Brain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      _search: "",
      status: "",
      frequency: "",
      dates: ""
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.searched = this.searched.bind(this);
    this.handleFrequency = this.handleFrequency.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.dateValues = this.dateValues.bind(this);
  }

  handleSearch = e => {
    if (e) {
      this.setState({ search: e.target.value, _search: e.target.value }, () =>
        this.props.handleSearch(this.state)
      );
    } else this.props.handleSearch(this.state);
  };

  searched = e => {
    this.setState({ search: e.target.value, _search: e.target.value });
  };

  handleStatus = value => {
    const status = value;
    this.setState({ status }, () => {
      this.props.handleSearch(this.state);
    });
  };

  handleFrequency = value => {
    const frequency = value;
    this.setState({ frequency }, () => {
      this.props.handleSearch(this.state);
    });
  };

  dateValues = dates => {
    this.setState({ dates }, () => {
      this.props.handleSearch(this.state);
    });
  };

  render() {
    return this.props.render({
      state: this.state,
      handleSearch: this.handleSearch,
      searched: this.searched,
      handleFrequency: this.handleFrequency,
      handleStatus: this.handleStatus,
      dateValues: this.dateValues
    });
  }
}

export const FilterDropdown = props => {
  const filters = (
    <>
      <StyledMenu>
        <StatusFilter
          handleDropper={props.handleStatus}
          menu={props.menu}
          cleared={props.cleared}
        />
        <Blocks h="20" />
        <TimeFrameMob dateValues={props.dateValues} cleared={props.cleared} />
          <>
            <Blocks h="20" />
            <FrequencyFilter
              handleDropper={props.handleFrequency}
              menu={props.menu}
              cleared={props.cleared}
            />
          </>
      </StyledMenu>
    </>
  );
  return (
    <>
      <DropdownList        
        getPopupContainer={() => document.getElementById("grants")}
        overlay={filters}
        style={{ marginLeft: "-40px" }}
      >
        <FilterWrapper>
          Filter
          <img src={funnel} alt = "funnel"/>
        </FilterWrapper>
      </DropdownList>
    </>
  );
};

export const TimeFrameMob = props => {
  return (
    <FlexCentered>
      <FlexCentered mr10>Timeframe:</FlexCentered>
      <TimeFrameComponent dateValues={props.dateValues} cleared={props.cleared}>
        Select TimeFrame
      </TimeFrameComponent>
    </FlexCentered>
  );
};

export const StatusFilter = props => {
  return (
    <FlexCentered>
      <>Status:</>
      {props.menu.status && (
        <MultiSelect          
          options={props.menu.status}
          handleDropper={props.handleDropper}
          placeholder="-Select-"
          cleared={props.cleared}
        />
      )}
    </FlexCentered>
  );
};
export const FrequencyFilter = props => {
  return (
    <FlexCentered>
      {props.menu.frequency && (
        <>
          <>Frequency:</>
          <MultiSelect
            options={props.menu.frequency}
            handleDropper={props.handleDropper}
            placeholder="-Select-"
            cleared={props.cleared}
          />
        </>
      )}
    </FlexCentered>
  );
};
